import SlideshowModalContainer from './SlideshowModalContainer';

export default SlideshowModalContainer;
